import React from 'react';
import useCards from '../../hooks/useCards';
import { Container } from '../components/Container';
import { CountCard, CountContainer } from '../components/CountCard';

const UserHome = () => {
  const { data: usersCount } = useCards();

  // const [dateRange, setDateRange] = useState<string[]>();

  return (
    <Container column>
      {/* <Header align='center' justify='space-between'>
        <DateRangeInput
          onChange={(range) => setDateRange(range)}
          value={dateRange}
        />
      </Header> */}
      <CountContainer style={{ margin: '3rem 0' }}>
        <CountCard column align='center' justify='center'>
          Total Reports
          <span className='count'>{usersCount?.report_count || '-'}</span>
        </CountCard>
        <CountCard column align='center' justify='center' color='green'>
          Total Tests
          <span className='count'>{usersCount?.test_count || '-'}</span>
        </CountCard>
        <CountCard column align='center' justify='center'>
          Average Rating
          <span className='count'>{usersCount?.average_rating || '-'}</span>
        </CountCard>
      </CountContainer>
    </Container>
  );
};

export default UserHome;
